export default __webpack_public_path__ + "static/media/exit.0f2a392f.wav";